import { Button, ButtonVariants } from '@comptia-sso/core';
import { ReactElement } from 'react';

// Styles.
import styles from './InstructorApproverHeader.module.scss';

interface IInstructorApproverEditHeaderProps {
  institutionId?: string;
}

export const InstructorApproverEditHeader = (
  props: IInstructorApproverEditHeaderProps,
): ReactElement => {
  const { institutionId } = props;

  return (
    <header className={styles.header}>
      <div className={styles.title}>
        <h1>Edit Instructor Approver</h1>
      </div>
      <div className={styles.breadcrumb}>
        <Button
          className={styles.back}
          link
          to={
            institutionId
              ? `/consent-approvers/institutions/${institutionId}`
              : '/consent-approvers'
          }
          variant={ButtonVariants.Secondary}
        >
          Back
        </Button>
      </div>
    </header>
  );
};
